const skipParseScoreboardsForComponentIds = [210];

export const shouldSkipParseScoreboards = (componentId: number): boolean => {
    return skipParseScoreboardsForComponentIds.includes(componentId);
};
